import axios from '../config/request';
const qs = require('qs');
// POST 方法封装  (参数处理)
export const postRequest = (url, params, headers = false) => {
    let _headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
    if (headers) {
        Object.assign(_headers, headers);
    }
    return axios({
        method: 'post',
        url: url,
        data: qs.stringify(params),
        headers: _headers
    });
};

// POST 方法封装  (文件上传)
export const uploadFileRequest = (url, params, headers = false) => {
    let _headers = { 'Content-Type': 'multipart/form-data' };
    if (headers) {
        Object.assign(_headers, headers);
    }
    return axios({
        method: 'post',
        url: url,
        data: params,
        headers: _headers
    });
};

//  GET 方法封装
export const getRequest = (url, query, headers = false) => {
    let _headers = {};
    if (headers) {
        Object.assign(_headers, headers);
    }
    return axios({
        url: url,
        method: 'get',
        params: query,
        headers: _headers
    });
};

//  PUT 方法封装
export const putRequest = (url, params, headers = false) => {
    let _headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
    if (headers) {
        Object.assign(_headers, headers);
    }
    return axios({
        method: 'put',
        url: url,
        data: qs.stringify(params),
        headers: _headers
    });
};

//  DELETE 方法封装
export const deleteRequest = url => {
    return axios({
        method: 'delete',
        url: url
    });
};

//  DELETE 方法封装
export const downloadRequest = (url,query, headers = false) => {
    let _headers = {};
    if (headers) {
        Object.assign(_headers, headers);
    }
    return axios({
        method: 'post',
        url: url,
        params: query,
        responseType: 'blob',
        headers: _headers
    });
};